export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/.9.6.1@rc-calendar/es/date/DateConstants.js
// module id = 278
// module chunks = 1